/**
 * @file Renders the modal that wraps the public key creation guide.
 */

import React from "react";

import { Modal } from "@components/Page";

import OrganizationPublicKeyGuide from "./OrganizationPublicKeyGuide";

const LABEL_TITLE = "How to Create a Public Key";

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

/**
 * Renders the guide inside a modal.
 */
const OrganizationPublicKeyGuideModal = ({
  isOpen,
  onClose,
}: Props): JSX.Element => {
  const modalProps = {
    title: LABEL_TITLE,
    isOpen,
    onClose,
  };

  return (
    <Modal {...modalProps}>
      <OrganizationPublicKeyGuide />
    </Modal>
  );
};

export default OrganizationPublicKeyGuideModal;
